import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HistInfo } from '../../../core/gb-api';
import { NgClass, NgStyle } from '@angular/common';
import { HistoryDirective } from '../../directives/history.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-kopfdatenelement',
  templateUrl: './kopfdatenelement.component.html',
  styleUrls: ['./kopfdatenelement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, NgClass, HistoryDirective, TranslatePipe]
})
export class KopfdatenelementComponent implements OnChanges {
  @Input() label: string;
  @Input() value: string | number;
  @Input() histInfo: HistInfo;
  @Input() labelClass = 'col-sm-auto col-md-auto col-lg-auto flex-33 text-nowrap';
  @Input() bodyClass = 'col-sm-8 col-md-6 col-lg-8';
  @Input() showZeroValue = false;
  @Input() backgroundColor;
  @Input() metaData;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    this.cd.markForCheck();
  }
}
